/****************************************************
 * Module Name:  addLusterModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import LusterProxy from "../../utility/proxy/manager/lusterProxy";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddLusterModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newluster: this.props.editOperation ? this.props.sourceData.name : "",
      newlusterfullname: this.props.editOperation
        ? this.props.sourceData.fullname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newwebref: this.props.editOperation ? this.props.sourceData.webref : "",

      showError: false,

      validateLusterPresentSpinner: false,
      showValidationMessage: false,
      lusterAvailable: true,

      lusterValidationError: "",
      fullNameValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newluster,
      fullname: this.state.newlusterfullname,
      description: this.state.newdescription,
      webref: this.state.newwebref,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateLusterPresent = (lusterEntered) => {
    if (!lusterEntered || lusterEntered.trim() === "") return;

    this.setState({
      validateLusterPresentSpinner: true,
    });

    LusterProxy.CheckLusterAvailable(lusterEntered, (response) => {
      //if we got response that means luster is present at backend
      if (response) {
        //LusterName already present
        this.setState({
          validateLusterPresentSpinner: false,
          showValidationMessage: true,
          lusterAvailable: false,
        });
      } else {
        //LusterName not available, so can be used
        this.setState({
          validateLusterPresentSpinner: false,
          showValidationMessage: true,
          lusterAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.newlusterfullname.length === 0)
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.lusterAvailable ||
        this.state.newlusterfullname.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add luster validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Luster" : "Add New Luster"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Luster Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Luster <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newluster}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Luster (required)"
                          placeholder="Enter Luster"
                          value={this.state.newluster}
                          autoFocus
                          onBlur={(e) =>
                            this.validateLusterPresent(this.state.newluster)
                          }
                          onChange={(e) =>
                            this.setState({
                              newluster: e.target.value,
                              showValidationMessage: false,
                              lusterValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Luster Cannot be Empty",
                            })
                          }
                          helperText={this.state.lusterValidationError}
                          error={this.state.lusterValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateLusterPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.lusterAvailable ? (
                        <font color="green">Luster available</font>
                      ) : (
                        <font color="red">Luster not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Luster Fullname <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Luster Fullname (required)"
                        placeholder="Enter Luster Fullname"
                        value={this.state.newlusterfullname}
                        onChange={(e) =>
                          this.setState({
                            newlusterfullname: e.target.value,
                            fullNameValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "Luster Fullname Cannot be Empty",
                          })
                        }
                        helperText={this.state.fullNameValidationError}
                        error={this.state.fullNameValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Web Reference</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Web Reference"
                        placeholder="Enter Web Reference"
                        value={this.state.newwebref}
                        onChange={(e) =>
                          this.setState({ newwebref: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
